// extracted by mini-css-extract-plugin
export default {"button":"Button_button__njOYy","buttonText":"Button_buttonText__i5HBM"};